module.exports = __webpack_public_path__ + "img/logo_desktop_250x250.06a39d90.jpg";